import {ReadyProvider} from '../../../application/providers/readyProvider';
import {SocialLoginButtons} from '../../../application/socialLoginButtons';

ReadyProvider.executeWithLazy(() => {
    SocialLoginButtons.init();
});
